import { ApiInstance } from "utils/Api";

import type { LeadsSnoozedFilters } from "modules/LeadsDashboard/queryKeys";

export const exportLeadsSnoozed = async (filters: LeadsSnoozedFilters) => {
  await ApiInstance.post("/leads/export/snoozed/enqueue", filters);
};
